import request from '@/utils/request';

/*
* 银行直贷 模块
* */

// 银行产品信息
export function getBankDetail(id) {
  return request({
    url: `/bank/query/financing/bank/${id}`,
    method: 'GET',
  });
}

// 工行特殊产品二维码
export function getICBCQRCode(id) {
  return request({
    url: `/bank/special/user/${id}`,
    method: 'GET',
  });
}

// 特惠产品专区  bankTypeLists:2
export function getBankAllTypePro(data) {
  const areaName = sessionStorage.getItem('areaName'); // 定位区域或用户选择区域
  return request({
    url: '/bank/query/special/financing/bank',
    method: 'POST',
    data: { ...data, areaName },
  });
}

// 重庆银行-新农贷预申请白名单检查
export function getCqWhite(data) {
  return request({
    url: '/cqbank/check/white',
    method: 'POST',
    data,
  });
}

// 重庆银行-已授信额度
export function getCqCredit(data) {
  return request({
    url: '/cqbank/credit',
    method: 'POST',
    data,
  });
}

// 重庆银行-申请
export function addCqAdvanceCredit(data) {
  return request({
    url: '/cqbank/advance/credit',
    method: 'POST',
    data,
  });
}
